import { z } from 'zod';
export const AddressSchema = z.object({
    street1: z.string().min(2),
    street2: z.string().min(0),
    city: z.string().min(2),
    state: z.string().min(2),
    postalCode: z.string().min(2),
    country: z.string().min(2),
});
